import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Button, Card, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
function HomeAthlete() {
  return (
    <Container fluid className="home-container">
      <Row>
        <Col sm={12}>
          <h1 className="text-center mt-2 mt-lg-5 mobileViewSet">
            Info: Ambassador<span className="text-primary">4</span>
            <span style={{ color: "red" }}>Brand</span>
          </h1>

          <Card className="p-3 my-4 mx-auto" style={{ maxWidth: "900px" }}>
            <div className="term-and-condition-main mt-2">
              <p className="terms-title">
                INFO for: Amateur athletes Becoming BRAND AMBASSADOR for
                FANSHELPPLAYERS brand group of websites and programs:
              </p>
              <div>
                <ul>
                  <li className="termsPoint">
                    <p>
                      By agreeing to do{" "}
                      <b>
                        <a
                          target="_blank"
                          href="https://athlete-for-brand.web.app"
                        >
                          AMBASSADOR4BRAND.com
                        </a>
                      </b>{" "}
                      work, you agree to be an <b>AMBASSADOR</b> for the{" "}
                      <b>FANSHELPPLAYERS</b> brand.
                    </p>
                  </li>
                  <li className="termsPoint">
                    <p>
                      The <b>FANSHELPPLAYERS</b> brand includes{" "}
                      <b>
                        <a
                          target="_blank"
                          href="https://fans-help-players-athlete.web.app"
                        >
                          FANSHELPPLAYERS.com
                        </a>
                      </b>
                      ,{" "}
                      <b>
                        <a
                          target="_blank"
                          href="https://match4future-platform.web.app"
                        >
                          MATCH4FUTURE.com
                        </a>
                      </b>
                      ,{" "}
                      <b>
                        <a
                          target="_blank"
                          href="https://collective-alums-main.web.app"
                        >
                          COLLECTIVEALUMS.com
                        </a>
                      </b>
                      ,{" "}
                      <b>
                        <a href="https://fhp-nft.web.app" target="_blank">
                          FHPNFT.com
                        </a>
                      </b>{" "}
                      ,
                      <b>
                        <a
                          href="https://athlete-for-brand.web.app"
                          target="_blank"
                        >
                          AMBASSADOR4BRAND.com
                        </a>
                      </b>{" "}
                      , and promotional support to a non-profit 501c3 called{" "}
                      <b>
                        <a target="_blank" href="https://unkle501.web.app">
                          UNKLE501.com
                        </a>
                      </b>
                      .
                    </p>
                  </li>
                  <li className="termsPoint">
                    <p>
                      You will be expected to{" "}
                      <b>
                        familiarize yourself with the sites (see summary of each
                        below).
                      </b>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </Card>

          <div className="text-center mb-4">
            <a
              href="https://youtu.be/uIWftF7cjug"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h5>https://youtu.be/uIWftF7cjug</h5>
            </a>
          </div>

          <Card className="p-3 my-4 mx-auto">
            <div className="pt-2 text-center">
              <Row className="justify-content-center align-items-center">
                <Col xs="12" md="12" lg="3" className="mb-2 mb-lg-0">
                  <Link to="/terms-and-condition-for-athlete">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      INSTANT CHAT
                    </Button>
                  </Link>
                </Col>
                <Col xs="12" md="12" lg="6" className="mb-2 mb-lg-0">
                  <Link to="/learn-with-expert-athlete">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      Learn to teach by video links & site experience
                    </Button>
                  </Link>
                </Col>
                <Col xs="12" md="12" lg="3">
                  <Link to="/summary-athlete">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      Summary
                    </Button>
                  </Link>
                </Col>
              </Row>
            </div>
          </Card>

          <Card className="p-3 my-4 mx-auto" style={{ maxWidth: "600px" }}>
            <h2 className="text-center home-title text-primary">IMPORTANT</h2>
            <p className="home-important-text text-center">
              During CHAT, please comply with rules of NCAA/amateur sports. Best
              not to discuss Gambling, Recruitment, Transfer Portal, alcohol,
              drugs, or other subject matter which could violate regulations.
            </p>
          </Card>

          <h5 className="mx-3 mx-sm-5 px-1 px-sm-2 text-center home-note-text">
            <b>Note:&nbsp;</b>The opinions offererd by teacher-athletes in their
            answers are not guaranteed to be accurate.For legal advice regarding
            amateur sport, please consult your own attorney.
          </h5>

          <div className="text-center mt-3">
            <p className="home-note-text">
              <span className="d-flex justify-content-center align-items-center flex-wrap">
                Continue:
                <strong className="mx-1 mb-0">
                  <Link to="/Login">
                    <span className="text-primary">Login</span>
                  </Link>
                </strong>
              </span>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default HomeAthlete;
